import { useContext } from 'react';

import { ApplicationContext } from '../../utils';
import { isDailyrentBannerArticle } from '../../utils/dailyrentBanner';
import type { IDailyrentBannerConfig } from '../../types/dailyrentBannerConfig';
import type { TPostState } from '../../types/post';
import { ERequestStatus } from '../../types/requestStatus';

export interface IUseDailyrentBannerResult {
  /** Заменять маркер в контенте статьи контейнером для баннера */
  isEnabledInContent: boolean;
  config: IDailyrentBannerConfig | undefined;
}

/**
 * Решает, показывать ли баннер посуточной аренды в статье: фичетогл включён
 * и статья есть в списке RS-конфига
 */
export const useDailyrentBanner = (post: TPostState): IUseDailyrentBannerResult => {
  const {
    custom: { dailyrentBannerConfig },
  } = useContext(ApplicationContext);
  /**
   * Пока статья грузится, в сторе ещё лежит предыдущая — смотрим на status,
   * иначе по её id решим, что баннер нужен и на новой странице
   */
  const isPostReady = post.status === ERequestStatus.Succeed && 'id' in post;
  const isEnabledInContent = isPostReady && isDailyrentBannerArticle(post.id, dailyrentBannerConfig);

  return {
    isEnabledInContent,
    config: isEnabledInContent ? dailyrentBannerConfig : undefined,
  };
};
